var _circle, _path, _rect;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
const SvgDownArrowPrimaryBg = props => /*#__PURE__*/React.createElement("svg", _extends({
  width: 26,
  height: 26,
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
  cx: 13,
  cy: 13,
  r: 12.5,
  fill: "#FE5F00",
  stroke: "#FE5F00"
})), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M13.293 19.266 8.024 15.46v-2.049l4.39 3.22v-9.19h1.757v9.19l4.39-3.22v2.049l-5.268 3.805Z",
  fill: "#fff"
})), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
  x: 20.817,
  y: 5.77,
  width: 15.049,
  height: 15.049,
  rx: 7.524,
  transform: "rotate(90 20.817 5.77)",
  stroke: "#FE5F00"
})));
export default SvgDownArrowPrimaryBg;